export default {
  'warehouse.tab.basic': '基本信息',
  'warehouse.field.file_no': '文件号',
  'warehouse.field.post_date': '过账日期',
  'warehouse.field.in_date': '入仓日期',
  'warehouse.field.out_date': '出仓日期',
  'warehouse.field.order_no': '订单号',
  'warehouse.field.order_date': '订单日期',
  'warehouse.field.container_no': '柜号',
  'warehouse.field.truck_bl_no': '卡车提单号',
  'warehouse.field.expect_date': '预计到仓日',
  'warehouse.field.expiration_date': '失效日期',
  'warehouse.field.warehouse_status': '状态',
  'warehouse.field.pallet': '托盘',
  'warehouse.field.pallet_remark': '托盘备注',
  'warehouse.field.remark': '备注',
  'warehouse.field.bill_to': '账单方',
  'warehouse.field.ship_from': '发货方',
  'warehouse.field.ship_to': '收货方',
  'warehouse.field.trucker': '车队',
  'warehouse.field.bl_no': '提单号',
  'warehouse.line.sku_no': 'SKU 编号',
  'warehouse.line.customer_po': '客户采购单号',
  'warehouse.line.product_description': '货品描述',
  'warehouse.line.order_po_no': '订单采购号',
  'warehouse.line.order_qty': '订单数量',
  'warehouse.line.qty': '数量',
  'warehouse.line.qty_unit': '单位',
  'warehouse.line.pcs': '件数',
  'warehouse.line.pack': '包装',
  'warehouse.line.pack_unit': '包装单位',
  'warehouse.line.pack_2': '包装2',
  'warehouse.line.pack_2_unit': '包装2单位',
  'warehouse.line.pallet': '托盘',
  'warehouse.line.weight': '重量',
  'warehouse.line.measurement': '体积',
  'warehouse.line.shipping_qty': '出库数量',
  'warehouse.line.allocated_qty': '分配数量',
  'warehouse.line.items': '明细',
  'warehouse.line.add': '添加行',
  'warehouse.status.pre_receiving': '待入库',
  'warehouse.status.received': '已入库',
  'warehouse.status.pre_shipping': '待出库',
  'warehouse.status.shipped': '已出库',
  'warehouse.action.confirm_shipped': '确认出库',
  'warehouse.action.confirm_received': '确认入库',
};
